import { createUseQueryHook } from 'hooks/createUseQueryHook';

export const useUserEmail = createUseQueryHook(
    'user_email',
    {
        staleTime: Infinity,
    },
);
